<template>
  <div class="slcb-toddy__dialog slcb-toddy__dialog--reply-box clearfix" v-if="question.response.has && question.response.show">
    <div class="slcb-toddy__dialog-icon-text float-right">
      <span class="slcb-toddy__dialog-icon slcb-toddy__dialog-icon--text align-top">{{ letterIcon }}</span>
    </div>
    <div class="slcb-toddy__dialog-text slcb-toddy__dialog-text--reply float-right">
      <p>{{ question.response.value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Response',
  props: ['question', 'letterIcon']
}
</script>



// WEBPACK FOOTER //
// src/components/Response.vue